/* Localized display copy; business data and variant values stay unchanged. */
function ifdpText(italian, english) {
  return (document.documentElement.lang || 'it').toLowerCase().split('-')[0] === 'en' ? english : italian;
}
// Preserve the language prefix for custom same-origin storefront actions.
function ifdpRoute(path) {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
    (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
  root = '/' + root.replace(/^\/+|\/+$/g, '');
  if(root !== '/') root += '/';
  if(root !== '/' && path.indexOf(root) === 0) return path;
  return root + path.replace(/^\//, '');
}
function ifdpAccountURL(loggedIn) {
  var routes = (window.theme && window.theme.routes) || {};
  return loggedIn ? (routes.account_url || ifdpRoute('/account')) :
    (routes.account_login_url || ifdpRoute('/account/login'));
}
/* ifiglidipapa custom.js - interazioni collezione (lean, delegation, no deps). */
(function(){
  'use strict';
  document.addEventListener('click', function(e){
    var open = e.target.closest('[data-ifdp-open]');
    if(open){ e.preventDefault(); document.body.classList.add('ifdp-filters-open'); ensureClose(); return; }
    if(e.target.closest('.ifdp-filter-overlay, .ifdp-filter-close')){ document.body.classList.remove('ifdp-filters-open'); return; }
    var tgl = e.target.closest('.ifdp-desc-toggle');
    if(tgl){
      var rte = document.querySelector('.collections__body .rte.ifdp-desc');
      if(rte){
        var exp = rte.classList.toggle('ifdp-desc--open');
        tgl.textContent = exp ? ifdpText("Mostra meno","Show less") : ifdpText("Mostra di più","Show more");
        tgl.setAttribute('aria-expanded', exp?'true':'false');
        // da richiuso il box si riclampa: se l'utente era sceso nel testo, riportalo in cima
        if(!exp){
          var top = rte.getBoundingClientRect().top + window.scrollY - 120;
          if(window.scrollY > top) window.scrollTo(0, Math.max(0, top));
        }
      }
      return;
    }
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') document.body.classList.remove('ifdp-filters-open'); });

  function ensureClose(){
    var sidebar = document.querySelector('.collections__sidebar');
    if(sidebar && !sidebar.querySelector('.ifdp-filter-close')){
      var x=document.createElement('button'); x.type='button'; x.className='ifdp-filter-close'; x.setAttribute('aria-label',ifdpText("Chiudi","Close")); x.innerHTML='&times;';
      sidebar.insertBefore(x, sidebar.firstChild);
    }
    // overlay (oscura lo sfondo quando i filtri sono aperti). Il CSS lo stila già
    // (.ifdp-filter-overlay), ma l'elemento non esisteva nel DOM → va creato qui.
    if(!document.querySelector('.ifdp-filter-overlay')){
      var ov=document.createElement('div'); ov.className='ifdp-filter-overlay'; ov.setAttribute('aria-hidden','true');
      // dentro <main>: stesso stacking context della sidebar (main ha z-index:2 e
      // intrappola il suo z-index 100001; da body l'overlay 100000 finiva SOPRA il drawer)
      (document.querySelector('main')||document.body).appendChild(ov);
    }
  }
  function initDesc(){
    var rte=document.querySelector('.collections__body .rte');
    if(!rte || rte.dataset.ifdpToggle) return;
    rte.dataset.ifdpToggle='1'; rte.classList.add('ifdp-desc');
    // v2 (2026-06-13): NIENTE manipolazione del contenuto. Il .rte resta intatto
    // (ordine documentale, H2/H3 delle pagine-brand riscritte inclusi) e da chiuso
    // viene solo CLIPPATO via CSS (max-height + fade), contenuto sempre renderizzato.
    // La v1 spappolava i <p> in una riga e gli H2 restavano visibili sopra la riga
    // (muro di titoloni sulle 8 pagine-brand del Cantiere B — bug Etro).
    requestAnimationFrame(function(){
      // descrizioni corte: niente clamp, niente bottone. Soglia ASSOLUTA su scrollHeight
      // (≈ altezza contenuto pieno): NON confrontare con clientHeight, che dipende dal
      // clamp CSS e va in race se custom.css non è ancora applicato al momento dell'init.
      if(rte.scrollHeight <= 90){ rte.classList.add('ifdp-desc--short'); return; }
      var t=document.createElement('button'); t.type='button'; t.className='ifdp-desc-toggle';
      t.textContent=ifdpText("Mostra di più","Show more"); t.setAttribute('aria-expanded','false');
      rte.parentNode.insertBefore(t, rte.nextSibling);
    });
  }

  // Lazyload fix: forza il caricamento delle immagini rimaste col placeholder gif
  // (logo + gallery prodotto + qualsiasi .rimage__img bloccata da lazyload).
  function fixLazyImages(scope){
    var root = scope || document;
    var imgs = root.querySelectorAll('.header__logo img, .header__logo .rimage__img, .rimage__img, img.lazyload');
    imgs.forEach(function(img){
      // mai forzare immagini NON visibili: le varianti per-breakpoint (display:none)
      // verrebbero scaricate inutilmente (audit perf 2026-06-12, ~1.3MB sprecati in home)
      if(!(img.offsetWidth>0 && img.offsetHeight>0)) return;
      var s = img.src || '';
      if(s.indexOf('data:image')===0 || s===''){
        var dss = img.getAttribute('data-srcset');
        var dsr = img.getAttribute('data-src');
        if(dss){ img.srcset = dss; var first = dss.split(',')[0].trim().split(' ')[0]; if(first) img.src = first.replace(/^\/\//,'https://'); }
        else if(dsr){ img.src = dsr.replace(/^\/\//,'https://'); }
        img.classList.remove('lazyload--hold');
        img.classList.add('lazyloaded');
      }
    });
  }
  function fixLogo(){ fixLazyImages(document); }
  // Observer persistente: la gallery prodotto e i nodi AJAX arrivano dopo init →
  // ogni volta che il DOM cambia, ricontrolla le immagini bloccate (debounced).
  (function(){
    if(!window.MutationObserver) return;
    var pending=false;
    var mo=new MutationObserver(function(){
      if(pending) return; pending=true;
      (window.requestAnimationFrame||setTimeout)(function(){ pending=false; fixLazyImages(document); clipTitles(); });
    });
    function start(){ if(document.body) mo.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['class','src','data-srcset']}); }
    if(document.body) start(); else document.addEventListener('DOMContentLoaded', start);
    // ri-valuta il clip dei titoli al resize (la soglia cambia con la larghezza della card)
    var rT; window.addEventListener('resize', function(){ clearTimeout(rT); rT=setTimeout(clipTitles, 150); });
  })();

  // === MEGA-MENU stile editoriale luxury: CATEGORIA + ACQUISTA PER DESIGNER + pannello immagine ===
  var CDN='https://cdn.shopify.com/s/files/1/0292/0762/5788/files/';
  // 1 immagine per categoria (editoriale, generata con imagegpt). Chiave = handle collection.
  var MEGA_IMG = {
    'neonati': CDN+'megamenu-neonati.png',
    'bambini': CDN+'megamenu-bambini.png',
    'ragazzi': CDN+'megamenu-ragazzi.png',
    'teenager': CDN+'megamenu-teen.png',
    'donna-1': CDN+'megamenu-donna.png',
    'abbigliamento': CDN+'megamenu-ragazzi.png',
    'accessori': CDN+'megamenu-teen.png'
  };
  // tutti i brand attivi (per ABBIGLIAMENTO/ACCESSORI/BRAND)
  var ALL_BRANDS=[{n:'Armani',h:'/collections/armani'},{n:'Balmain',h:'/collections/balmain'},{n:'Barrow',h:'/collections/barrow'},{n:'Bonpoint',h:'/collections/bonpoint'},{n:'Etro',h:'/collections/etro'},{n:'Fay',h:'/collections/fay'},{n:'Jeckerson',h:'/collections/jeckerson'},{n:'Maison Margiela',h:'/collections/maison-margiela'},{n:'Manila Grace',h:'/collections/manila-grace'},{n:'Max&co',h:'/collections/max-co'},{n:'Monnalisa',h:'/collections/monnalisa'},{n:'Moschino',h:'/collections/moschino'},{n:'Palm Angels',h:'/collections/palm-angels'},{n:'Polo Ralph Lauren',h:'/collections/polo-ralph-lauren'},{n:'Pucci',h:'/collections/pucci'},{n:"Roy Roger's",h:'/collections/roy-rogers'},{n:'Self-Portrait',h:'/collections/self-portrait'},{n:'Simonetta',h:'/collections/simonetta'},{n:'Woolrich',h:'/collections/woolrich'},{n:'Anonyme',h:'/collections/anonyme'}];
  // Brand attivi per fascia (vendor reali, brand dismessi esclusi), ordinati per assortimento.
  var MEGA_BRANDS = {
    'neonati':[{n:'Moschino',h:'/collections/moschino'},{n:'Monnalisa',h:'/collections/monnalisa'},{n:'Armani',h:'/collections/armani'},{n:'Polo Ralph Lauren',h:'/collections/polo-ralph-lauren'},{n:'Etro',h:'/collections/etro'},{n:'Balmain',h:'/collections/balmain'},{n:'Fay',h:'/collections/fay'},{n:'Bonpoint',h:'/collections/bonpoint'},{n:'Jeckerson',h:'/collections/jeckerson'},{n:"Roy Roger's",h:'/collections/roy-rogers'},{n:'Simonetta',h:'/collections/simonetta'}],
    'bambini':[{n:'Moschino',h:'/collections/moschino'},{n:'Armani',h:'/collections/armani'},{n:'Monnalisa',h:'/collections/monnalisa'},{n:'Polo Ralph Lauren',h:'/collections/polo-ralph-lauren'},{n:'Jeckerson',h:'/collections/jeckerson'},{n:'Bonpoint',h:'/collections/bonpoint'},{n:'Etro',h:'/collections/etro'},{n:'Barrow',h:'/collections/barrow'},{n:"Roy Roger's",h:'/collections/roy-rogers'},{n:'Woolrich',h:'/collections/woolrich'},{n:'Self-Portrait',h:'/collections/self-portrait'}],
    'ragazzi':[{n:'Barrow',h:'/collections/barrow'},{n:'Maison Margiela',h:'/collections/maison-margiela'},{n:'Balmain',h:'/collections/balmain'},{n:'Max&co',h:'/collections/max-co'},{n:'Armani',h:'/collections/armani'},{n:'Palm Angels',h:'/collections/palm-angels'},{n:'Monnalisa',h:'/collections/monnalisa'},{n:"Roy Roger's",h:'/collections/roy-rogers'},{n:'Moschino',h:'/collections/moschino'},{n:'Jeckerson',h:'/collections/jeckerson'},{n:'Fay',h:'/collections/fay'},{n:'Etro',h:'/collections/etro'},{n:'Polo Ralph Lauren',h:'/collections/polo-ralph-lauren'},{n:'Manila Grace',h:'/collections/manila-grace'},{n:'Woolrich',h:'/collections/woolrich'},{n:'Self-Portrait',h:'/collections/self-portrait'}],
    'teenager':[{n:'Polo Ralph Lauren',h:'/collections/polo-ralph-lauren'},{n:'Maison Margiela',h:'/collections/maison-margiela'},{n:'Barrow',h:'/collections/barrow'},{n:'Balmain',h:'/collections/balmain'},{n:'Max&co',h:'/collections/max-co'},{n:'Armani',h:'/collections/armani'},{n:'Manila Grace',h:'/collections/manila-grace'},{n:'Palm Angels',h:'/collections/palm-angels'},{n:"Roy Roger's",h:'/collections/roy-rogers'},{n:'Etro',h:'/collections/etro'},{n:'Fay',h:'/collections/fay'},{n:'Moschino',h:'/collections/moschino'},{n:'Jeckerson',h:'/collections/jeckerson'},{n:'Pucci',h:'/collections/pucci'}],
    'donna-1':[{n:'Anonyme',h:'/collections/anonyme'}],
    'abbigliamento':ALL_BRANDS, 'accessori':ALL_BRANDS, 'i-nostri-brand':ALL_BRANDS
  };
  // Sotto-categorie per fascia (dal menu Shella). Le costruiamo da dati per evitare
  // i conflitti di posizionamento dei dropdown annidati di Shella.
  var MEGA_CATS = {
    'neonati':[{n:'Neonata',h:'/collections/neonata'},{n:'Neonato',h:'/collections/neonato'},{n:'Unisex',h:'/collections/neonati-1'}],
    'bambini':[{n:'Bambina',h:'/collections/bambina'},{n:'Bambino',h:'/collections/bambino'},{n:'Unisex',h:'/collections/bambini-1'}],
    'ragazzi':[{n:'Ragazza',h:'/collections/ragazza'},{n:'Ragazzo',h:'/collections/ragazzo'},{n:'Unisex',h:'/collections/ragazzi-1'}],
    'teenager':[{n:'Femmina',h:'/collections/teen-femmina'},{n:'Maschio',h:'/collections/teen-maschio'},{n:'Unisex',h:'/collections/teen-unisex'}],
    'donna-1':[],
    'abbigliamento':[{n:'Capispalla',h:'/collections/capispalla'},{n:'Completi e Abiti',h:'/collections/completi-e-abiti'},{n:'Costumi da bagno',h:'/collections/costumi-da-bagno'},{n:'Intimo',h:'/collections/intimo-1'},{n:'Jeans e Pantaloni',h:'/collections/jeans-e-pantaloni'},{n:'Top e Maglieria',h:'/collections/tops'},{n:'Tute',h:'/collections/tute'},{n:'Tutine e Body',h:'/collections/tutine-e-body'}],
    'accessori':[{n:'Bavaglini',h:'/collections/bavaglini'},{n:'Calze e Calzamaglie',h:'/collections/calze-e-calzamaglie'},{n:'Cappelli',h:'/collections/cappelli'},{n:'Cinte e Bretelle',h:'/collections/cinte-e-bretelle'},{n:'Coperte',h:'/collections/coperte'},{n:'Cravatte e Foulard',h:'/collections/cravatte-papillon-e-foulard'},{n:'Guanti',h:'/collections/guanti'},{n:'Sciarpe',h:'/collections/sciarpe'},{n:'Calzature',h:'/collections/calzature'}],
    'i-nostri-brand':[]
  };
  function megaKey(href){
    return (href||'').replace('/en','').replace('/collections/','').replace('/pages/','').replace(/\?.*$/,'').replace(/\/$/,'').replace(/^\//,'');
  }
  function linkList(arr){
    var ul=document.createElement('ul'); ul.className='ifdp-mega__list';
    arr.forEach(function(b){ var li=document.createElement('li'); var a=document.createElement('a'); a.href=b.h; a.textContent=b.n; li.appendChild(a); ul.appendChild(li); });
    return ul;
  }
  function buildCatCol(key, href, label){
    var col=document.createElement('div'); col.className='ifdp-mega__col ifdp-mega__col--cat';
    var h=document.createElement('div'); h.className='ifdp-mega__h'; h.textContent='Categoria'; col.appendChild(h);
    var all=document.createElement('a'); all.className='ifdp-mega__all ifdp-mega__all--top'; all.href=href; all.textContent='Vedi tutto '+label; col.appendChild(all);
    var cats=MEGA_CATS[key]||[];
    if(cats.length){ var ul=linkList(cats); ul.classList.add('ifdp-mega__list--cat'); col.appendChild(ul); }
    return col;
  }
  function buildBrandCol(key){
    var brands=MEGA_BRANDS[key]; if(!brands || !brands.length) return null;
    var col=document.createElement('div'); col.className='ifdp-mega__col ifdp-mega__col--brands';
    var h=document.createElement('div'); h.className='ifdp-mega__h'; h.textContent='Acquista per designer'; col.appendChild(h);
    var ul=linkList(brands); ul.classList.add('ifdp-mega__brandlist'); col.appendChild(ul);
    var all=document.createElement('a'); all.className='ifdp-mega__all'; all.href='/pages/i-nostri-brand'; all.textContent='Vedi tutti i brand'; col.appendChild(all);
    return col;
  }
  function initMega(){ return; /* disabilitato 2026-05-30: mega-menu ora reso lato Liquid da ifdp-mega-panel via header-get-menu-dropdown */
    var items=document.querySelectorAll('.header__line-bottom .menu__level-01 > .menu__item');
    items.forEach(function(it){
      if(it.dataset.megaDone) return;
      var a=it.querySelector(':scope > a'); if(!a) return;
      var href=(a.getAttribute('href')||'');
      var key=megaKey(href);
      // attiva il mega SOLO sulle fasce d'età mappate
      if(!MEGA_IMG[key] && !MEGA_BRANDS[key]) return;
      // Il pannello bianco con bg/bordo/ombra è il .menu__level-02 INTERNO (non il
      // .menu__dropdown esterno). Applichiamo il flex-layout LÌ.
      var dd=it.querySelector('.menu__dropdown .menu__level-02') || it.querySelector('.menu__level-02') || it.querySelector('.menu__dropdown');
      if(!dd) return;
      dd.classList.add('ifdp-mega-dd');
      it.dataset.megaDone='1';
      it.classList.add('ifdp-mega');
      var label=(a.textContent||'').trim();

      // Nascondi gli item nativi di Shella dentro il pannello (li ricostruiamo da dati).
      [].slice.call(dd.children).forEach(function(el){
        if(!el.classList.contains('ifdp-mega__col') && !el.classList.contains('ifdp-mega__img')){
          el.classList.add('ifdp-mega__native-hide');
        }
      });

      var imgEl=null;
      // --- Colonna 3 (immagine) prima, così possiamo inserire le altre prima di lei
      var img=MEGA_IMG[key];
      if(img && !dd.querySelector('.ifdp-mega__img')){
        imgEl=document.createElement('a');
        imgEl.className='ifdp-mega__img'; imgEl.href=href;
        imgEl.style.backgroundImage='url('+img+')';
        imgEl.innerHTML='<span class="ifdp-mega__cap">'+label+'<small>SCOPRI ORA</small></span>';
        dd.appendChild(imgEl);
      } else { imgEl=dd.querySelector('.ifdp-mega__img'); }

      // --- Colonna 1: CATEGORIA (costruita da dati)
      if(!dd.querySelector('.ifdp-mega__col--cat')){
        var catCol=buildCatCol(key, href, label);
        dd.insertBefore(catCol, dd.firstChild);
      }
      // --- Colonna 2: DESIGNER
      if(!dd.querySelector('.ifdp-mega__col--brands')){
        var brandCol=buildBrandCol(key);
        if(brandCol){ if(imgEl) dd.insertBefore(brandCol, imgEl); else dd.appendChild(brandCol); }
      }
    });
  }
  // Titoli prodotto: 1 sola riga in griglia (card allineate). Marca .is-clipped quelli che
  // sforano → il CSS li sfuma a destra (mask-image) invece di tagliarli con "…".
  function clipTitles(){
    var els=document.querySelectorAll('.product-collection__title h4, .product-collection__title h4 a, .product-collection__title a');
    [].forEach.call(els, function(el){
      // misura sul nodo che contiene davvero il testo (no wrapper vuoti)
      if(!el.firstChild) return;
      var clipped = el.scrollWidth > el.clientWidth + 1;
      el.classList.toggle('is-clipped', clipped);
    });
  }
  function init(){ initDesc(); ensureClose(); fixLogo(); initMega(); clipTitles(); }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  var n=0, iv=setInterval(function(){ init(); if(++n>=4) clearInterval(iv); }, 400);
})();

/* ============ HEADER STICKY (JS, robusto: body ha overflow che rompe position:sticky) ============ */
(function(){
  'use strict';
  var sh, spacer, lastStuck=false, baseTop=0;
  function el(){ return document.querySelector('sticky-header'); }
  function setup(){
    sh = el(); if(!sh || sh.dataset.ifdpSticky) return; sh.dataset.ifdpSticky='1';
    // spacer per evitare il salto quando passiamo a fixed
    spacer=document.createElement('div'); spacer.className='ifdp-sticky-spacer'; spacer.setAttribute('aria-hidden','true');
    sh.parentNode.insertBefore(spacer, sh.nextSibling);
    onScroll();
  }
  function tapeH(){ var t=document.querySelector('.js-header-tape'); return t && getComputedStyle(t).display!=='none' ? t.getBoundingClientRect().height : 0; }
  function onScroll(){
    if(!sh) return;
    if(window.innerWidth < 992){ unstick(); return; }   // sticky solo desktop
    var trigger = (spacer ? spacer.offsetTop : sh.offsetTop) - 0;
    // quando scrolliamo oltre la tape annuncio, fissa la barra (logo+menu)
    var threshold = tapeH();
    var stuck = window.pageYOffset > (sh.offsetTop + threshold) && window.pageYOffset > 60;
    if(stuck && !lastStuck){
      spacer.style.height = sh.getBoundingClientRect().height + 'px';
      document.documentElement.classList.add('ifdp-stuck');
      lastStuck=true;
    } else if(!stuck && lastStuck){
      unstick();
    }
  }
  function unstick(){ if(spacer) spacer.style.height='0px'; document.documentElement.classList.remove('ifdp-stuck'); lastStuck=false; }
  function boot(){ setup(); }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function(){ if(sh){ sh.dataset.ifdpSticky=''; } setup(); });
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll);
})();

/* ============ HEADER ICONS + SHOPIFY ACCOUNT NAVIGATION ============ */
(function(){
  'use strict';
  // Shopify selects the configured account experience and available providers.
  function openAuth(){ window.location.assign(ifdpAccountURL(false)); }

  function initHeader(){
    // nascondi help (?), wire account -> popup, ordina, aggiungi label Cerca
    var help=document.querySelector('.header__btn-services'); if(help) help.style.display='none';
    // Cuore wishlist nell'header, subito DOPO la ricerca (richiesta Fabio: "il cuore in alto accanto
    // alla ricerca", niente launcher fluttuante). Click -> apre il drawer Froonze via toggleWidget().
    // Idempotente. Il contatore riflette ifdpWish/Froonze ed e' aggiornato da syncCount() altrove.
    var search=document.querySelector('.header__btn-search');
    if(search && !document.querySelector('.ifdp-header-wish')){
      var wish=document.createElement('a');
      wish.href='#';
      wish.className='header__btn-wish ifdp-header-wish position-relative d-flex align-items-center ml-25 ml-lg-15';
      wish.setAttribute('aria-label',ifdpText("La mia wishlist","My wishlist"));
      wish.dataset.ifdpIcon='1';
      wish.innerHTML='<i class="position-relative d-inline-flex"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" class="ifdp-header-ic ifdp-header-wish__icon" aria-hidden="true" focusable="false">'
        +'<path d="M12 20.5C7 17.3 3.5 13.9 3.5 9.8 3.5 7.1 5.6 5 8.2 5c1.7 0 3.1.9 3.8 2.2C12.7 5.9 14.1 5 15.8 5c2.6 0 4.7 2.1 4.7 4.8 0 4.1-3.5 7.5-8.5 10.7Z"/>'
        +'</svg><span class="ifdp-header-wish__count is-empty" aria-hidden="true"></span></i>';
      wish.addEventListener('click', function(e){
        e.preventDefault();
        try{
          if(window.frcp && window.frcp.wishlist && typeof window.frcp.wishlist.toggleWidget==='function'){
            window.frcp.wishlist.toggleWidget();
            return;
          }
        }catch(err){}
        window.location.href=ifdpRoute('/account'); // fallback se l'app wishlist non e' caricata
      });
      // inserisci subito dopo la ricerca
      if(search.nextSibling){ search.parentNode.insertBefore(wish, search.nextSibling); }
      else { search.parentNode.appendChild(wish); }
    }
    // allinea il contatore del cuore header alla wishlist reale (storage dell'app wishlist).
    // count=0 -> badge nascosto (mai un numero sbagliato: per gli utenti loggati lo stato
    // vive lato server e qui potrebbe risultare vuoto).
    function ifdpWishCount(){
      var n=0;
      try{
        var d=JSON.parse(localStorage.getItem('frcp_wishlist')||'{}');
        var ids={};
        var pl=d.product_id_lists||{};
        Object.keys(pl).forEach(function(k){ Object.keys(pl[k]||{}).forEach(function(id){ ids[id]=1; }); });
        var g=d.guest||{};
        Object.keys(g.addProductId||{}).forEach(function(id){ ids[id]=1; });
        Object.keys(g.removeProductId||{}).forEach(function(id){ delete ids[id]; });
        n=Object.keys(ids).length;
      }catch(e){}
      document.querySelectorAll('.ifdp-header-wish__count').forEach(function(c){
        if(n>0){ c.textContent=n; c.classList.remove('is-empty'); }
        else { c.textContent=''; c.classList.add('is-empty'); }
      });
    }
    ifdpWishCount();
    window.addEventListener('storage', ifdpWishCount);
    // i bottoni wishlist dell'app scrivono lo storage poco dopo il tap: ricontrolla due volte (idempotente)
    document.addEventListener('click', function(e){
      // cuori sulle card/PDP + qualunque azione dentro il widget (rimozioni incluse):
      // l'evento storage non scatta nella stessa tab, quindi rileggiamo noi (idempotente)
      if(e.target.closest('.frcp-wishlist-btn') || e.target.closest('[class*="frcp-popup"]')){
        setTimeout(ifdpWishCount, 400); setTimeout(ifdpWishCount, 1500);
      }
    });
    // Icona carrello = LINK alla pagina /cart (stile editoriale luxury: l'icona NON apre il drawer;
    // il drawer/notifica si apre SOLO dopo "aggiungi al carrello"). Shella aggancia il popup
    // via class js-popup-button + data-js-popup-button="cart": rimuovendoli, l'<a href="/cart">
    // torna un link normale. Idempotente.
    var cartBtn=document.querySelector('.header__btn-cart');
    if(cartBtn && !cartBtn.dataset.ifdpCartLink){
      cartBtn.dataset.ifdpCartLink='1';
      cartBtn.classList.remove('js-popup-button');
      cartBtn.removeAttribute('data-js-popup-button');
      if(!cartBtn.getAttribute('href')) cartBtn.setAttribute('href',ifdpRoute('/cart'));
      // cintura+bretelle: se un listener fosse gia attaccato, forziamo comunque la navigazione
      cartBtn.addEventListener('click', function(e){
        if(e.defaultPrevented) return;
        window.location.href = cartBtn.getAttribute('href') || ifdpRoute('/cart');
      });
    }
    var account=document.querySelector('.header__btn-account');
    if(account && !account.dataset.popupBound){
      account.dataset.popupBound='1';
      account.setAttribute('href', ifdpAccountURL(document.body.classList.contains('customer-logged-in')));
      // Rimuovi gli hook popup nativi di Shella (come fatto per il carrello): senza questo,
      // Shella apre ANCHE il suo popup fixed-stretch (z-index 999999) sopra il nostro #ifdp-auth
      // (z 100050) -> il popup login appare ingrigito e non cliccabile finche' non si clicca fuori
      // per chiudere quello fantasma. (audit 2026-06-07)
      account.classList.remove('js-popup-button');
      account.removeAttribute('data-js-popup-button');
      account.addEventListener('click', function(e){
        // Use the Shopify account route for the configured customer-account experience.
        if(!document.body.classList.contains('customer-logged-in')){ e.preventDefault(); e.stopPropagation(); openAuth('login'); }
      });
    }
    // chiusura barra annuncio (la × nativa di Shella non ha handler attivo).
    // Usa una classe (non inline) perché il force-visible CSS ha !important.
    var tape=document.querySelector('.js-header-tape');
    if(tape){
      try{ if(localStorage.getItem('ifdpTapeClosed')==='1'){ tape.classList.add('ifdp-tape-hidden'); } }catch(e){}
      var x=tape.querySelector('.header__tape-close, [class*="tape-close"], .ifp-ann__close');
      if(x && !x.dataset.ifdpClose){
        x.dataset.ifdpClose='1';
        x.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          tape.classList.add('ifdp-tape-hidden');
          try{ localStorage.setItem('ifdpTapeClosed','1'); }catch(err){}
        });
      }
      // "10% sul primo ordine: registrati ora" → apre il popup registrazione invece di /account/register
      var reg=tape.querySelector('[data-ifdp-register]');
      if(reg && !reg.dataset.ifdpRegWired){
        reg.dataset.ifdpRegWired='1';
        reg.addEventListener('click', function(e){ e.preventDefault(); openAuth('register'); });
      }
    }
  }
  // Mobile (stile editoriale luxury): l'icona account è nascosta dalla barra header via CSS;
  // qui aggiungiamo "Accedi / Il mio account" in cima al drawer hamburger così resta raggiungibile.
  // Il menu Shella è popolato via JS → iniettiamo nella zona head del popup-navigation (sempre presente),
  // e usiamo openAuth() (stesso popup editoriale dell'icona) se non loggato, altrimenti link a /account.
  function injectAccountInMenu(){
    var nav=document.querySelector('.popup-navigation .popup-navigation__head .container');
    if(!nav || nav.querySelector('.ifdp-menu-account')) return;
    var logged=document.body.classList.contains('customer-logged-in');
    var a=document.createElement('a');
    a.className='ifdp-menu-account';
    a.href=ifdpAccountURL(logged);
    a.innerHTML='<span class="ifdp-menu-account__ic" aria-hidden="true">'
      +'<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 3.6-6 8-6s8 2 8 6"/></svg>'
      +'</span><span class="ifdp-menu-account__tx">'+(logged?ifdpText("Il mio account","My account"):ifdpText("Accedi / Registrati","Sign in / Register"))+'</span>';
    if(!logged){
      a.addEventListener('click', function(e){ e.preventDefault(); openAuth('login'); });
    }
    nav.appendChild(a);
  }

  // Icone header in stile editoriale (outline sottile, arrotondate) al posto delle stock Shella (fill, pesanti).
  // Sostituisce SOLO l'<svg> dentro il primo <i> del bottone → preserva i contatori (wishlist/cart count).
  var IFDP_HEADER_ICONS = {
    'search':   '<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>',
    'account':  '<circle cx="12" cy="8" r="4"/><path d="M4 21c0-4.2 3.6-7 8-7s8 2.8 8 7"/>',
    'wishlist': '<path d="M12 20.5C7 17.3 3.5 13.9 3.5 9.8 3.5 7.1 5.6 5 8.2 5c1.7 0 3.1.9 3.8 2.2C12.7 5.9 14.1 5 15.8 5c2.6 0 4.7 2.1 4.7 4.8 0 4.1-3.5 7.5-8.5 10.7Z"/>',
    'cart':     '<path d="M5.6 8.2h12.8a.8.8 0 0 1 .8.86l-.76 9.5a2 2 0 0 1-2 1.84H7.56a2 2 0 0 1-2-1.84l-.76-9.5a.8.8 0 0 1 .8-.86Z"/><path d="M8.8 8.2V7a3.2 3.2 0 0 1 6.4 0v1.2"/>'
  };
  // a11y: nomi accessibili per le icone-solo-SVG dell'header (audit 2026-06-07)
  var IFDP_ICON_LABELS = {
    'search':   ifdpText("Cerca","Search"),
    'account':  ifdpText("Il mio account","My account"),
    'wishlist': ifdpText("La mia wishlist","My wishlist"),
    'cart':     ifdpText("Carrello","Cart"),
    'menu':     'Menu'
  };
  function labelHeaderIcon(btn, k){
    if(!btn) return;
    // Forza sempre l'aria-label: il "testo" di queste icone e' solo il badge numerico
    // (es. il contatore carrello "0"), che non e' un nome accessibile utile.
    if(!btn.getAttribute('aria-label')){
      btn.setAttribute('aria-label', IFDP_ICON_LABELS[k] || k);
    }
    var svg=btn.querySelector('svg'); if(svg){ svg.setAttribute('aria-hidden','true'); svg.setAttribute('focusable','false'); }
  }
  function restyleHeaderIcons(){
    // hamburger (non e' nella mappa icone ma serve il nome accessibile)
    labelHeaderIcon(document.querySelector('.header__btn-menu'), 'menu');
    Object.keys(IFDP_HEADER_ICONS).forEach(function(k){
      var btn=document.querySelector('.header__btn-'+k);
      labelHeaderIcon(btn, k);
      if(!btn || btn.dataset.ifdpIcon) return;
      var i=btn.querySelector('i'); if(!i) return;
      var svg=i.querySelector('svg'); if(!svg) return;
      btn.dataset.ifdpIcon='1';
      svg.setAttribute('viewBox','0 0 24 24');
      svg.setAttribute('fill','none');
      svg.setAttribute('stroke','currentColor');
      svg.setAttribute('stroke-width','1.4');
      svg.setAttribute('stroke-linecap','round');
      svg.setAttribute('stroke-linejoin','round');
      svg.classList.add('ifdp-header-ic');
      svg.innerHTML = IFDP_HEADER_ICONS[k];
      // Carrello: sposta il contatore desktop DENTRO l'<i> (l'icona) così il bollino si ancora
      // all'angolo dell'icona, non al bottone (che è più largo) → sovrapposto, non staccato.
      if(k==='cart'){
        var cnt=btn.querySelector('[data-js-cart-count-desktop]');
        if(cnt && cnt.parentNode!==i){ i.appendChild(cnt); }
      }
    });
  }

  function boot(){ initHeader(); injectAccountInMenu(); restyleHeaderIcons(); }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

/* ============ PAGINA PRODOTTO: logo brand + badge NOVITÀ + sconto + wishlist ============ */
(function(){
  'use strict';
  if(!/\/products\//.test(location.pathname)) return;
  var NEW_DAYS=30;
  var LCDN='https://cdn.shopify.com/s/files/1/0292/0762/5788/files/';
  // vendor (lowercase) -> URL logo brand (da carousel-brands, verificati 200)
  var BRAND_LOGOS={
    'anonyme':LCDN+'anonyme_bac486ae-d419-4e28-8b8b-294e8e1c6b88.png',
    'armani':LCDN+'armani-junior-vector-logo_f85219e1-f694-4e02-90b9-922fdad0bca5.png',
    'balmain':LCDN+'Balmain-Logo.png',
    'barrow':LCDN+'barrow-seeklogo_2d774dd0-f898-4a59-97a5-73b8d6141211.jpg',
    'bonpoint':LCDN+'png-clipart-bonpoint-clothing-child-retail-haute-couture-child-angle-child.png',
    'etro':LCDN+'Etro-logo.png',
    'fay':LCDN+'fay_194db171-49d7-49d1-a2be-6b89800677d3.png',
    'jeckerson':LCDN+'Jeckerson_a472cf4a-a1be-4dd6-83a2-02c044aef554.png',
    'manila grace':LCDN+'Manila_Grace_71696be8-34bc-4d96-ab65-c92d7e197e84.png',
    'maison margiela':LCDN+'maison-margiela-paris5667.logowik.com.webp',
    'max & co.':LCDN+'maxandco-logo-vector.png',
    'monnalisa':LCDN+'Monnalisa.png',
    'moschino':LCDN+'Moschino_f1b7c1f2-6df4-4d37-ba16-e3c765cfbb42.png',
    'palm angels':LCDN+'palm-angels-seeklogo.svg',
    'peuterey':LCDN+'Peuterey_43d32749-48f6-4297-bc3b-36b697a385d4.png',
    'polo ralph lauren':LCDN+'ralphlauren_1.svg',
    'pucci':LCDN+'pucci.webp',
    "roy roger's":LCDN+'Roy_Roger_s_2_998ea224-7789-42ba-8981-edb5bcbab65d.png',
    'self-portrait':LCDN+'Self-Portrait_Black.png',
    'simonetta':LCDN+'simonetta.svg',
    'the north face':LCDN+'the-north-face-1.svg',
    'woolrich':LCDN+'Woolrich.png'
  };
  function maxDiscount(variants){
    var max=0;
    variants.forEach(function(v){
      var p=v.price/100, c=v.compare_at_price?v.compare_at_price/100:0;
      if(c&&p&&c>p){ var pct=Math.round((1-p/c)*100); if(pct>max) max=pct; }
    });
    return max;
  }
  function brandLogo(prod){
    // sostituisci il testo "BRAND: X" col logo del brand e MOVILO sopra al titolo (stile editoriale)
    var v=document.querySelector('.product-page-info__vendor');
    if(!v || v.dataset.ifdpLogo) return;
    var vendor=(prod.vendor||'').toString().trim().toLowerCase().replace(/\s+/g,' ');
    var url=BRAND_LOGOS[vendor];
    if(!url) return;
    v.dataset.ifdpLogo='1'; v.classList.add('ifdp-has-logo');
    var img=document.createElement('img'); img.className='ifdp-brand-logo'; img.alt=prod.vendor; img.src=url; img.loading='eager';
    var a=document.createElement('a'); a.href='/collections/'+(prod.vendor||'').toString().trim().toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,''); a.appendChild(img);
    v.textContent=''; v.appendChild(a);
    // riordino DOM: logo PRIMA del titolo (nome prodotto sotto al logo)
    var title=document.querySelector('.product-page-info__title');
    if(title && title.parentNode===v.parentNode){ v.parentNode.insertBefore(v, title); }
    else if(title && title.parentNode){ title.parentNode.insertBefore(v, title); }
  }
  function badges(prod){
    var info=document.querySelector('.product-page-info'); if(!info || info.dataset.ifdpBadges) return; info.dataset.ifdpBadges='1';
    if(prod.published_at){
      var age=(Date.now()-new Date(prod.published_at).getTime())/86400000;
      if(age>=0 && age<=NEW_DAYS){
        var title=info.querySelector('.product-page-info__title');
        if(title){ var nb=document.createElement('div'); nb.className='ifdp-pdp-novita'; nb.textContent=ifdpText("NOVITÀ","NEW"); title.parentNode.insertBefore(nb, title); }
      }
    }
    var pct=maxDiscount(prod.variants||[]);
    if(pct>0){ var price=info.querySelector('.product-page-info__price'); if(price){ var sb=document.createElement('span'); sb.className='ifdp-pdp-discount'; sb.textContent='-'+pct+'%'; price.appendChild(sb); } }
  }
  function wishHeart(prod){ return; /* ifdp wishlist disabled - Froonze owns it */
    var info=document.querySelector('.product-page-info'); if(!info || info.dataset.ifdpWish) return; info.dataset.ifdpWish='1';
    var btn=document.createElement('button'); btn.type='button'; btn.className='ifdp-pdp-wish'; btn.setAttribute('aria-label',ifdpText("Aggiungi alla wishlist","Add to wishlist"));
    btn.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 21s-7.5-4.6-9.7-9.2C.9 8.6 2.3 5.5 5.3 5c2-.3 3.7.8 4.7 2.3C11 5.8 12.7 4.7 14.7 5c3 .5 4.4 3.6 3 6.8C19.5 16.4 12 21 12 21z"/></svg>';
    var key='ifdpWish';
    function ids(){ try{ return JSON.parse(localStorage.getItem(key)||'[]'); }catch(e){ return []; } }
    var pid=String(prod.id);
    if(ids().indexOf(pid)>=0) btn.classList.add('is-active');
    btn.addEventListener('click', function(){
      var arr=ids(); var i=arr.indexOf(pid);
      if(i>=0){ arr.splice(i,1); btn.classList.remove('is-active'); }
      else{ arr.push(pid); btn.classList.add('is-active'); }
      try{ localStorage.setItem(key, JSON.stringify(arr)); }catch(e){}
      // sincronizza il contatore wishlist header se presente
      var c=document.querySelector('.header__btn-wishlist .header__counter'); if(c) c.textContent=arr.length;
    });
    info.appendChild(btn);
  }
  // #13 Trustpilot: nascondi il widget generico ("Leggi le nostre N recensioni su Trustpilot").
  // Il nostro widget custom (metafield-driven) lo rende la sezione ifdp-product-details lato server.
  function hideGenericTP(){
    [].slice.call(document.querySelectorAll('a,div,p,span')).forEach(function(e){
      if(e.dataset && e.dataset.ifdpTpHid) return;
      if(e.querySelector && e.querySelector('.tp-widget')) return; // non nascondere il nostro
      var t=(e.textContent||'');
      if(/Leggi le nostre[\s\S]*recensioni/i.test(t) && e.children.length<6 && e.getBoundingClientRect().height<140){
        e.style.display='none'; if(e.dataset) e.dataset.ifdpTpHid='1';
      }
    });
  }
  function titleCase(){
    // il nome prodotto nel catalogo è MAIUSCOLO (Quick) → portalo a Sentence case
    var t=document.querySelector('.product-page-info__title'); if(!t || t.dataset.ifdpCased) return;
    var txt=(t.textContent||'').trim(); if(!txt || txt!==txt.toUpperCase()) { t.dataset.ifdpCased='1'; return; }
    var SMALL={'e':1,'di':1,'da':1,'con':1,'in':1,'a':1,'il':1,'la':1,'lo':1,'le':1,'i':1,'gli':1,'per':1,'del':1,'dei':1};
    var words=txt.toLowerCase().split(/\s+/).map(function(w,idx){
      if(idx>0 && SMALL[w]) return w;
      return w.charAt(0).toUpperCase()+w.slice(1);
    });
    t.textContent=words.join(' '); t.dataset.ifdpCased='1';
  }
  // #16 Selettore taglie a tendina (stile editoriale luxury): "Scegli" + taglia | prezzo / Avvisami
  function sizeDropdown(prod){
    var sec=document.querySelector('.product-options__section[data-property="size"]');
    if(!sec || sec.dataset.ifdpDd) return;
    var vals=[].slice.call(sec.querySelectorAll('.product-options__value--text'));
    if(!vals.length) return;
    // se c'è una sola taglia non serve la tendina (resta com'è)
    sec.dataset.ifdpDd='1';
    // mappa taglia(normalizzata) -> {available, price, id} dai variant.
    // NB: le pill native usano data-value tipo "912m" mentre l'option variant è "9/12M" → normalizzo
    // entrambe togliendo tutto tranne alfanumerici, cosi' le chiavi combaciano.
    function norm(s){ return (''+(s||'')).toLowerCase().replace(/[^a-z0-9]/g,''); }
    var byOpt={}; var cur=window.Shopify&&Shopify.currency?Shopify.currency.active:'EUR';
    // determina quale option index è la TAGLIA (option che NON è il colore): uso prod.options
    var sizeIdx=-1;
    if(prod.options && prod.options.length){
      prod.options.forEach(function(o,idx){ var n=(o.name||o||'').toString().toLowerCase(); if(n.indexOf('size')>=0||n.indexOf('taglia')>=0) sizeIdx=idx; });
      if(sizeIdx<0 && prod.options.length>1) sizeIdx=1; // fallback: 2ª opzione = taglia
      if(sizeIdx<0) sizeIdx=0;
    }
    (prod.variants||[]).forEach(function(v){
      var opts=[v.option1,v.option2,v.option3];
      var sizeVal=opts[sizeIdx];
      if(sizeVal){
        var k=norm(sizeVal);
        if(!byOpt[k] || v.available) byOpt[k]={available:v.available, price:v.price, id:v.id};
      }
      opts.forEach(function(o){ if(o){ var kk=norm(o); if(!byOpt[kk]) byOpt[kk]={available:v.available, price:v.price, id:v.id}; } });
    });
    function fmtPrice(cents){ try{ return new Intl.NumberFormat(document.documentElement.lang || 'it', {style:'currency', currency:cur}).format(cents/100); }catch(e){ return ''; } }
    // costruisci il select custom
    var wrap=document.createElement('div'); wrap.className='ifdp-size-dd';
    var sel=document.createElement('button'); sel.type='button'; sel.className='ifdp-size-dd__btn';
    // a11y (audit 2026-06-07): nome accessibile + stato del dropdown taglia custom
    sel.setAttribute('aria-label',ifdpText("Taglia","Size")); sel.setAttribute('aria-haspopup','listbox'); sel.setAttribute('aria-expanded','false');
    sel.innerHTML='<span>'+ifdpText("Scegli","Choose")+'</span><i class="ifdp-size-dd__chev" aria-hidden="true">⌄</i>';
    var list=document.createElement('div'); list.className='ifdp-size-dd__list'; list.hidden=true; list.setAttribute('role','listbox'); list.setAttribute('aria-label',ifdpText("Seleziona la taglia","Select a size"));
    var basePrice=(prod.price!=null)?prod.price:((prod.variants&&prod.variants[0])?prod.variants[0].price:null);
    vals.forEach(function(v){
      var label=v.getAttribute('data-display-value') || v.textContent.trim(); var key=norm(v.getAttribute('data-value')||label);
      // affidabilità: la classe .disabled nativa di Shella riflette la disponibilità per il colore selezionato
      var avail=!v.classList.contains('disabled');
      var info=byOpt[key]||{};
      var price=(info.price!=null)?info.price:basePrice;
      var opt=document.createElement('button'); opt.type='button'; opt.className='ifdp-size-dd__opt'+(avail?'':' is-oos');
      var right=avail ? (price!=null?fmtPrice(price):'') : ifdpText("Avvisami","Notify me");
      var optionLabel=document.createElement('span'); optionLabel.textContent=label; var optionDetail=document.createElement('span'); optionDetail.className='ifdp-size-dd__r'; optionDetail.textContent=right; opt.appendChild(optionLabel); opt.appendChild(optionDetail);
      opt._native=v; opt._label=label; opt._vid=(info && info.id) || null;
      opt.addEventListener('click', function(){
        // Seleziona SEMPRE la variante nativa, anche se esaurita.
        v.click();
        // BRIDGE per app back-in-stock (STOQ): aggiorna l'input [name="id"] del form prodotto
        // con la variante della taglia scelta + dispatch 'change', cosi' STOQ rileva la variante
        // esaurita e mostra "Avvisami". Il nostro click sulle pill esaurite non aggiorna l'id da solo.
        if(this._vid){
          var forms=document.querySelectorAll('form[action*="/cart/add"]');
          forms.forEach(function(f){
            var idIn=f.querySelector('[name="id"]');
            if(idIn){ idIn.value=String(this._vid); idIn.dispatchEvent(new Event('change',{bubbles:true})); idIn.dispatchEvent(new Event('input',{bubbles:true})); }
          }.bind(this));
          try{ if(window._RestockRocket && typeof window._RestockRocket.renderButtonForVariant==='function') window._RestockRocket.renderButtonForVariant(Number(this._vid)); }catch(e){}
        }
        sel.querySelector('span').textContent=label;
        var isOos=this.classList.contains('is-oos');
        sel.parentNode && sel.parentNode.classList.toggle('ifdp-size-dd--oos', isOos);
        // marca la buy box come "taglia esaurita scelta" → il CSS nasconde "Aggiungi al carrello" (resta "Avvisami")
        var info2=document.querySelector('.product-page-info'); if(info2) info2.classList.toggle('ifdp-pdp-oos', isOos);
        list.hidden=true; wrap.classList.remove('is-open'); sel.setAttribute('aria-expanded','false');
      });
      list.appendChild(opt);
    });
    function refresh(){ // ri-leggi disponibilità dalle pill native (cambia col colore)
      [].slice.call(list.children).forEach(function(opt){
        var avail=!opt._native.classList.contains('disabled');
        opt.classList.toggle('is-oos', !avail);
        var r=opt.querySelector('.ifdp-size-dd__r');
        if(r) r.textContent = avail ? (basePrice!=null?fmtPrice(basePrice):'') : ifdpText("Avvisami","Notify me");
      });
    }
    sel.addEventListener('click', function(){ var op=list.hidden; if(op) refresh(); list.hidden=!op; wrap.classList.toggle('is-open', op); sel.setAttribute('aria-expanded', op?'true':'false'); });
    document.addEventListener('click', function(e){ if(!wrap.contains(e.target)){ list.hidden=true; wrap.classList.remove('is-open'); } });
    wrap.appendChild(sel); wrap.appendChild(list);
    sec.parentNode.insertBefore(wrap, sec.nextSibling);
    sec.classList.add('ifdp-native-size-hidden');
  }
  // Sposta "GUIDA ALLE TAGLIE" SOPRA il dropdown taglia (stile editoriale: vicino al selettore taglia,
  // non in fondo alla buy box). Estrae solo il bottone size-guide, lascia delivery-return/message dov'erano.
  function moveSizeGuideAboveSize(){
    var btn=document.querySelector('[data-js-popup-button="size-guide"]');
    if(!btn || btn.dataset.ifdpMoved) return false;
    // ancora: il dropdown taglia custom (.ifdp-size-dd) o, in fallback, la section taglia nativa
    var dd=document.querySelector('.ifdp-size-dd') || document.querySelector('.product-options__section[data-property="size"]');
    if(!dd) return false;
    var col=btn.closest('.col-auto') || btn;
    var link=document.createElement('div');
    link.className='ifdp-sizeguide-link';
    // riuso il bottone nativo (mantiene l'handler popup di Shella): lo sposto dentro un contenitore sopra il dropdown
    btn.dataset.ifdpMoved='1';
    link.appendChild(btn);
    dd.parentNode.insertBefore(link, dd);
    // se il vecchio contenitore .col-auto e' rimasto vuoto, rimuovilo
    if(col!==btn && col.parentNode && !col.querySelector('[data-js-popup-button]')) col.remove();
    return true;
  }

  function run(){
    var h=(location.pathname.match(/\/products\/([^/?]+)/)||[])[1]; if(!h) return;
    fetch(ifdpRoute('/products/'+h+'.js'),{credentials:'same-origin'}).then(function(r){return r.ok?r.json():null;}).then(function(p){ if(p){ brandLogo(p); badges(p); titleCase(); sizeDropdown(p); /* ifdp wishHeart removed: Froonze now owns wishlist */ } }).catch(function(){});
    hideGenericTP(); titleCase();
    // il dropdown taglia si crea async (dopo il fetch products.js) → ritenta finche' non c'e'
    var tries=0, iv=setInterval(function(){ if(moveSizeGuideAboveSize() || ++tries>=12) clearInterval(iv); }, 350);
  }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();

/* ============ WIDGET TRUSTPILOT custom: stelle + recensioni rotanti ============ */
(function(){
  'use strict';
  function star(filled){ var i=document.createElement('i'); if(!filled) i.className='is-empty'; return i; }
  function renderStars(container, rating, max){
    container.innerHTML='';
    for(var n=1;n<=max;n++) container.appendChild(star(n<=Math.round(rating)));
  }
  function initTrustpilot(){
    var w=document.querySelector('.tp-widget'); if(!w || w.dataset.tpInit) return; w.dataset.tpInit='1';
    var score=parseFloat(w.getAttribute('data-tp-score'))||5, max=parseInt(w.getAttribute('data-tp-max'),10)||5;
    var top=w.querySelector('.tp-widget__stars'); if(top) renderStars(top, score, max);
    w.querySelectorAll('.tp-rev__stars').forEach(function(s){ renderStars(s, parseInt(s.getAttribute('data-r'),10)||5, max); });
    var revs=[].slice.call(w.querySelectorAll('.tp-rev')); if(!revs.length) return;
    var idx=0; revs[0].classList.add('is-active');
    if(revs.length>1){
      setInterval(function(){
        revs[idx].classList.remove('is-active');
        idx=(idx+1)%revs.length;
        revs[idx].classList.add('is-active');
      }, 4500);
    }
  }
  if(document.readyState!=='loading') initTrustpilot(); else document.addEventListener('DOMContentLoaded', initTrustpilot);
  document.addEventListener('shopify:section:load', initTrustpilot);
  var t=0,iv=setInterval(function(){ initTrustpilot(); if(++t>=4) clearInterval(iv); },400);
})();

/* ============ PDP: merchant-confirmed Italy shipping services ============ */
(function(){
  'use strict';
  function render(){
    var info=document.querySelector('.product-page-info'); if(!info || info.dataset.ifdpDelivery) return;
    info.dataset.ifdpDelivery='1';
    // ancora: subito dopo il bottone carrello (.product-page-info__details-buttons-wrap o il form)
    var anchor = info.querySelector('.product-page-info__details-buttons')
              || info.querySelector('.product-page-info__free-shipping')
              || info.querySelector('.product-page-info__payments')
              || info.querySelector('form');
    if(!anchor) return;
    // Delivery service ranges, without calculating a promised calendar date.
    var box=document.createElement('div'); box.className='ifdp-delivery';
    box.textContent=ifdpText('Spedizioni in Italia: Standard 2–4 giorni lavorativi · Express 1–2 giorni lavorativi', 'Shipping in Italy: Standard 2–4 working days · Express 1–2 working days');
    anchor.parentNode.insertBefore(box, anchor);
    // (2) Riquadro spedizione/reso/ritiro (stile editoriale), subito dopo la consegna
    if(!info.querySelector('.ifdp-shipbox')){
      var sb=document.createElement('div'); sb.className='ifdp-shipbox';
      sb.textContent=ifdpText('Spedizione gratuita in Italia per ordini da €180 · Resi entro 30 giorni', 'Free shipping in Italy on orders of €180 or more · Returns within 30 days');
      box.parentNode.insertBefore(sb, box.nextSibling);
    }
    // (3) Rimuovi il link "CONSEGNA E RESO" dalla pagina (il popup resta nel DOM per SEO).
    //     Nascondi solo il bottone delivery-return, lascia size-guide/message se presenti.
    var drBtn=info.querySelector('[data-js-popup-button="delivery-return"]');
    if(drBtn){ var col=drBtn.closest('.col-auto')||drBtn; col.style.display='none'; }
  }
  function run(){ if(!document.querySelector('.product-page-info')) return; render(); }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();

/* ============ PAGINA CARRELLO: dropdown taglia/quantita con AUTO-UPDATE (no bottone) ============
   Event delegation su document → un solo set di listener, sopravvive al re-render AJAX.
   - Taglia: /cart/update.js keyed per variant_id ({old:0, new:qty}) = atomico, somma se duplicato.
   - Quantita: /cart/change.js {id:line_key, quantity:N}.
   - Re-render: fetch /cart?view=ajax → sostituisce .js-page-cart-ajax (template cart.ajax.liquid).
   Ricetta validata. */
(function(){
  'use strict';
  function busy(on){ var p=document.querySelector('.js-page-cart-ajax'); if(p) p.classList.toggle('ifdp-cart--busy', !!on); }
  function rerender(){
    return fetch(ifdpRoute('/cart?view=ajax'), {credentials:'same-origin'})
      .then(function(r){ return r.ok ? r.text() : null; })
      .then(function(html){
        if(html==null) { location.reload(); return; }
        var holder=document.querySelector('.js-page-cart-ajax');
        // il template ritorna il wrapper esterno; estraggo il contenuto di .js-page-cart-ajax
        var tmp=document.createElement('div'); tmp.innerHTML=html;
        var fresh=tmp.querySelector('.js-page-cart-ajax');
        if(holder && fresh){ holder.innerHTML = fresh.innerHTML; }
        else if(holder){ holder.innerHTML = html; }
        // aggiorna i contatori carrello dell'header
        fetch(ifdpRoute('/cart.js'),{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){
          document.querySelectorAll('[data-js-cart-count-desktop]').forEach(function(e){ e.textContent='('+c.item_count+')'; });
          document.querySelectorAll('[data-js-cart-count-mobile]').forEach(function(e){ e.textContent=c.item_count; });
        }).catch(function(){});
      })
      .catch(function(){ location.reload(); });
  }
  function changeQty(lineKey, qty){
    busy(true);
    return fetch(ifdpRoute('/cart/change.js'),{method:'POST',headers:{'Content-Type':'application/json'},credentials:'same-origin',
      body:JSON.stringify({id:lineKey, quantity:qty})})
      .then(function(){ return rerender(); }).then(function(){ busy(false); })
      .catch(function(){ busy(false); location.reload(); });
  }
  function changeVariant(oldId, newId, qty){
    if(String(oldId)===String(newId)) return;
    busy(true);
    var updates={}; updates[oldId]=0; updates[newId]=qty||1;
    return fetch(ifdpRoute('/cart/update.js'),{method:'POST',headers:{'Content-Type':'application/json'},credentials:'same-origin',
      body:JSON.stringify({updates:updates})})
      .then(function(){ return rerender(); }).then(function(){ busy(false); })
      .catch(function(){ busy(false); location.reload(); });
  }
  // delegation: change su select taglia/quantita
  document.addEventListener('change', function(e){
    var sizeSel=e.target.closest && e.target.closest('[data-size-select]');
    if(sizeSel){
      sizeSel.disabled=true;
      changeVariant(sizeSel.getAttribute('data-current-id'), sizeSel.value, parseInt(sizeSel.getAttribute('data-qty'),10)||1);
      return;
    }
    var qtySel=e.target.closest && e.target.closest('[data-qty-select]');
    if(qtySel){
      qtySel.disabled=true;
      changeQty(qtySel.getAttribute('data-line-key'), parseInt(qtySel.value,10)||1);
      return;
    }
  });
  // delegation: rimozione riga (intercetta il link /cart/change?line=…&quantity=0 → AJAX + rerender)
  document.addEventListener('click', function(e){
    var rm=e.target.closest && e.target.closest('.ifdp-cart__line-remove[data-line-key]');
    if(rm){ e.preventDefault(); changeQty(rm.getAttribute('data-line-key'), 0); }
  });
  // delegation: "Sposta nella Wishlist" → salva product id in ifdpWish (stessa chiave PDP/card) + rimuove dal carrello
  document.addEventListener('click', function(e){
    var w=e.target.closest && e.target.closest('[data-cart-wish]');
    if(!w) return;
    e.preventDefault();
    var KEY='ifdpWish';
    var pid=String(w.getAttribute('data-product-id')||'');
    if(false && pid){ /* ifdp wishlist write disabled - Froonze owns it */
      var arr; try{ arr=JSON.parse(localStorage.getItem(KEY)||'[]'); }catch(err){ arr=[]; }
      if(arr.indexOf(pid)<0){ arr.push(pid); try{ localStorage.setItem(KEY, JSON.stringify(arr)); }catch(err){} }
      // sincronizza i contatori wishlist header
      document.querySelectorAll('.header__btn-wishlist .header__counter, .header__btn-wishlist [class*="counter"]').forEach(function(c){ c.textContent=arr.length; });
    }
    // poi rimuovi la riga dal carrello (stesso meccanismo della ×)
    changeQty(w.getAttribute('data-line-key'), 0);
  });
})();

/* ============ PDP: "Visti di recente" (localStorage) ============
   Traccia gli ultimi prodotti visti e popola il carosello data-ifdp-recent. */
(function(){
  'use strict';
  if(!/\/products\//.test(location.pathname)) return;
  var KEY='ifdpRecent';
  function read(){ try{ return JSON.parse(localStorage.getItem(KEY)||'[]'); }catch(e){ return []; } }
  function write(a){ try{ localStorage.setItem(KEY, JSON.stringify(a)); }catch(e){} }
  var curHandle=(location.pathname.match(/\/products\/([^/?]+)/)||[])[1];

  var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  function fmtPrice(cents){ try{ return new Intl.NumberFormat(document.documentElement.lang || 'it', {style:'currency', currency:cur}).format(cents/100); }catch(e){ return ''; } }
  function card(p){
    var img=(p.featured_image||(p.images&&p.images[0])||'');
    if(img && img.indexOf('//')===0) img='https:'+img;
    var web = (p.metafields && p.metafields.custom && p.metafields.custom.titolo_web) ? p.metafields.custom.titolo_web : null; // di norma non in products.js
    var title=p.title||'';
    var d=document.createElement('div'); d.className='ifdp-recent-card';
    // alt descrittivo (brand + nome) per a11y; niente loading=lazy: la card e' iniettata via JS
    // gia' nel viewport quando la sezione e' visibile, il lazy nativo a volte non scatta (audit 2026-06-07).
    var altTxt=((p.vendor?p.vendor+' ':'')+title).replace(/"/g,'&quot;').trim();
    d.innerHTML='<a href="'+p.url+'">'
      +(img?'<img src="'+img.replace(/(\.[a-z]+)(\?|$)/i,'_400x$1$2')+'" alt="'+altTxt+'" decoding="async">':'')
      +'<div class="ifdp-recent-card__brand">'+(p.vendor||'')+'</div>'
      +'<div class="ifdp-recent-card__name">'+title+'</div>'
      +'<div class="ifdp-recent-card__price">'+fmtPrice(p.price)+'</div>'
      +'</a>';
    return d;
  }
  function renderRecent(){
    var wrap=document.querySelector('[data-ifdp-recent]'); if(!wrap) return;
    var track=wrap.querySelector('[data-ifdp-recent-track]'); if(!track) return;
    var minItems=parseInt(wrap.getAttribute('data-ifdp-min'),10)||4; // < min => carosello nascosto (scelta Fabio)
    var handles=read().filter(function(h){ return h && h!==curHandle; }).slice(0,12);
    if(handles.length<minItems){ wrap.hidden=true; return; }
    var done=0, frags=[];
    handles.forEach(function(h,idx){
      fetch(ifdpRoute('/products/'+h+'.js'),{credentials:'same-origin'})
        .then(function(r){ return r.ok?r.json():null; })
        .then(function(p){ if(p) frags[idx]=card(p); })
        .catch(function(){})
        .then(function(){
          done++;
          if(done===handles.length){
            track.innerHTML='';
            frags.forEach(function(f){ if(f) track.appendChild(f); });
            if(track.children.length>=minItems){ wrap.hidden=false; } else { wrap.hidden=true; }
          }
        });
    });
  }
  function track(){
    var arr=read().filter(function(h){ return h!==curHandle; });
    arr.unshift(curHandle);
    // dedup mantenendo l'ordine, max 24
    var seen={}, out=[];
    arr.forEach(function(h){ if(h && !seen[h]){ seen[h]=1; out.push(h); } });
    write(out.slice(0,24));
  }
  function init(){ track(); renderRecent(); }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', renderRecent);
})();

/* ============ CUORICINO WISHLIST sulle card prodotto (stile editoriale) ============
   Inietta un cuore in alto a destra su ogni .product-collection (collezione, caroselli, ricerca).
   Toggle in localStorage 'ifdpWish' (stessa chiave della PDP). Aggiorna il contatore header. */
(function(){
  'use strict';
  var KEY='ifdpWish';
  function ids(){ try{ return JSON.parse(localStorage.getItem(KEY)||'[]'); }catch(e){ return []; } }
  function save(a){ try{ localStorage.setItem(KEY, JSON.stringify(a)); }catch(e){} }
  function syncCount(){ var n=ids().length; document.querySelectorAll('.header__btn-wishlist .header__counter, .header__btn-wishlist [class*="counter"]').forEach(function(c){ c.textContent=n; }); }
  var HEART='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20.3C7.2 17.2 4 14 4 10.1 4 7.6 6 5.6 8.5 5.6c1.6 0 3 .8 3.5 2.1.5-1.3 1.9-2.1 3.5-2.1C18 5.6 20 7.6 20 10.1c0 3.9-3.2 7.1-8 10.2Z"/></svg>';
  function inject(scope){ return; /* ifdp card wishlist disabled - Froonze owns it */
    (scope||document).querySelectorAll('.product-collection__image').forEach(function(imgWrap){
      var card=imgWrap.closest('.product-collection,[data-product-handle]');
      if(!card || imgWrap.querySelector('.ifdp-card-wish')) return;
      var handle=card.getAttribute('data-product-handle') || (card.querySelector('a[href*="/products/"]')||{}).getAttribute && (card.querySelector('a[href*="/products/"]').getAttribute('href').match(/\/products\/([^/?]+)/)||[])[1];
      if(!handle) return;
      var pid=card.getAttribute('data-product-variant-id') || handle; // chiave: handle (stabile)
      var btn=document.createElement('button');
      btn.type='button'; btn.className='ifdp-card-wish'; btn.setAttribute('aria-label',ifdpText("Aggiungi alla wishlist","Add to wishlist"));
      btn.setAttribute('data-wish-handle', handle);
      btn.innerHTML=HEART;
      if(ids().indexOf(handle)>=0) btn.classList.add('is-active');
      imgWrap.appendChild(btn);
    });
  }
  document.addEventListener('click', function(e){
    var btn=e.target.closest && e.target.closest('.ifdp-card-wish');
    if(!btn) return;
    e.preventDefault(); e.stopPropagation();
    var h=btn.getAttribute('data-wish-handle'); if(!h) return;
    var arr=ids(), i=arr.indexOf(h);
    if(i>=0){ arr.splice(i,1); btn.classList.remove('is-active'); }
    else { arr.push(h); btn.classList.add('is-active'); }
    save(arr); syncCount();
    // sincronizza altri cuori dello stesso prodotto in pagina
    document.querySelectorAll('.ifdp-card-wish[data-wish-handle="'+h+'"]').forEach(function(o){ o.classList.toggle('is-active', arr.indexOf(h)>=0); });
  });
  function init(){ inject(document); syncCount(); }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function(){ inject(document); });
  // i caroselli/AJAX aggiungono card dopo: re-inietta su mutazioni (debounced)
  if(window.MutationObserver){
    var pend=false;
    new MutationObserver(function(){ if(pend) return; pend=true; (window.requestAnimationFrame||setTimeout)(function(){ pend=false; inject(document); }); })
      .observe(document.documentElement, {childList:true, subtree:true});
  }
})();

/* ============ POPUP EXIT-INTENT sulla pagina CARRELLO (stile editoriale luxury) ============
   Compare quando l'utente sta per lasciare il carrello: mouse fuori dall'alto (desktop),
   tasto indietro (mobile), o click su "Continua a fare acquisti"/link di uscita.
   1 volta a sessione. Tutto frontend. */
(function(){
  'use strict';
  if(!/\/cart(\/|$|\?)/.test(location.pathname+location.search) && location.pathname!=='/cart') return;
  // gira solo sulla pagina carrello
  if(location.pathname.replace(/\/$/,'') !== ifdpRoute('/cart').replace(/\/$/,'')) return;

  var SHOWN_KEY='ifdpCartExitShown';
  function alreadyShown(){ try{ return sessionStorage.getItem(SHOWN_KEY)==='1'; }catch(e){ return false; } }
  function markShown(){ try{ sessionStorage.setItem(SHOWN_KEY,'1'); }catch(e){} }

  var built=false, overlay;
  function build(){
    if(built) return; built=true;
    overlay=document.createElement('div');
    overlay.className='ifdp-exit'; overlay.setAttribute('aria-hidden','true');
    overlay.innerHTML=''
      +'<div class="ifdp-exit__bg" data-exit-stay></div>'
      +'<div class="ifdp-exit__panel" role="dialog" aria-modal="true" aria-label="'+ifdpText("Abbandonare il carrello","Leave your cart")+'">'
      +  '<button type="button" class="ifdp-exit__x" data-exit-stay aria-label="'+ifdpText("Chiudi","Close")+'">&times;</button>'
      +  '<h2 class="ifdp-exit__title">'+ifdpText("Vuoi davvero abbandonare il carrello?","Leave your cart?")+'</h2>'
      +  '<p class="ifdp-exit__text">'+ifdpText("Puoi continuare a fare acquisti o restare qui per controllare il tuo carrello.","You can continue shopping or stay here to review your cart.")+'</p>'
      +  '<div class="ifdp-exit__actions">'
      +    '<button type="button" class="ifdp-exit__leave" data-exit-leave>'+ifdpText("Lascia il carrello","Leave cart")+'</button>'
      +    '<button type="button" class="ifdp-exit__stay" data-exit-stay>'+ifdpText("RESTA NEL CARRELLO","STAY IN CART")+'</button>'
      +  '</div>'
      +'</div>';
    document.body.appendChild(overlay);
    overlay.addEventListener('click', function(e){
      if(e.target.closest('[data-exit-stay]')){ close(); }
      else if(e.target.closest('[data-exit-leave]')){ close(); leaveNow=true; window.location.href=ifdpRoute('/collections/all'); }
    });
  }
  var leaveNow=false;
  function open(){
    if(alreadyShown()) return;
    build(); markShown();
    overlay.classList.add('is-open'); overlay.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('ifdp-exit-lock');
  }
  function close(){
    if(!overlay) return;
    overlay.classList.remove('is-open'); overlay.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('ifdp-exit-lock');
  }

  // (a) DESKTOP exit-intent: mouse esce dall'alto del viewport
  document.addEventListener('mouseout', function(e){
    if(alreadyShown()) return;
    if(window.innerWidth < 768) return; // desktop only per il mouse
    if(!e.relatedTarget && !e.toElement && e.clientY <= 4){ open(); }
  });

  // (b) MOBILE: tentativo di "indietro" → intercetta con history
  if(window.innerWidth < 768){
    try{ history.pushState({ifdpCart:1}, ''); }catch(e){}
    window.addEventListener('popstate', function(){
      if(!alreadyShown()){ try{ history.pushState({ifdpCart:1}, ''); }catch(e){} open(); }
    });
  }

  // (c) click su link che PORTA FUORI dal carrello (es. "Continua a fare acquisti")
  document.addEventListener('click', function(e){
    if(alreadyShown() || leaveNow) return;
    var a=e.target.closest('a.ifdp-cart__continue-top, a.ifdp-cart__continue, a[href="/collections/all"], a[href*="/collections/"]');
    // solo se siamo sul carrello e il link porta a navigare via (non checkout, non azioni)
    if(a && !e.defaultPrevented){
      var href=a.getAttribute('href')||'';
      if(/\/collections\//.test(href)){
        e.preventDefault();
        open();
        // se poi sceglie "Lascia il carrello" lo mando alla destinazione che voleva
        overlay.querySelector('[data-exit-leave]').onclick=function(){ close(); leaveNow=true; window.location.href=href; };
      }
    }
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });
})();

/* ============ FROONZE WISHLIST sulle CARD (collezione + caroselli) ============
   Inietta il bottone wishlist NATIVO di Froonze su ogni card prodotto, usando
   l'API frcp.wishlist.attachProductBtnAtPlaceholder. Stile minimale via custom.css
   (.frcp-wishlist-btn). Cuore sull'immagine in alto a destra (stile card editoriale).
   Sostituisce il vecchio ifdp-card-wish. Aggiunto 2026-06-05. */
(function(){
  'use strict';
  var DONE='ifdpFrcpCard';
  function api(){ return window.frcp && window.frcp.wishlist; }
  function inject(scope){
    var w=api(); if(!w || typeof w.attachProductBtnAtPlaceholder!=='function') return;
    (scope||document).querySelectorAll('.product-collection').forEach(function(card){
      var img=card.querySelector('.product-collection__image');
      if(!img || img.dataset[DONE] || img.querySelector('.frcp-wishlist-btn')) return;
      var handle=card.getAttribute('data-product-handle');
      if(!handle){
        var a=card.querySelector('a[href*="/products/"]');
        handle=a ? (a.getAttribute('href').match(/\/products\/([^/?#]+)/)||[])[1] : null;
      }
      if(!handle) return;
      var vid=card.getAttribute('data-product-variant-id')||null;
      var title=(card.querySelector('.product-collection__title,[class*=title]')||{}).textContent||handle;
      img.dataset[DONE]='1';
      // ensure a stable placeholder id
      if(!img.id) img.id='ifdp-wish-'+handle.replace(/[^a-z0-9-]/gi,'')+'-'+Math.floor(Math.random()*1e6);
      try{ w.attachProductBtnAtPlaceholder('#'+CSS.escape(img.id), handle, null, vid, 'append', (title||'').trim()); }
      catch(e){ /* noop */ }
    });
    if(typeof w.updateWishlistButtonsStatus==='function'){ try{ w.updateWishlistButtonsStatus(); }catch(e){} }
  }
  function ready(cb){
    // attende che l'API Froonze sia pronta
    if(api() && api().attachProductBtnAtPlaceholder){ cb(); return; }
    var n=0, iv=setInterval(function(){ if((api()&&api().attachProductBtnAtPlaceholder) || ++n>=40){ clearInterval(iv); if(api()) cb(); } }, 250);
  }
  function init(){ ready(function(){ inject(document); }); }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function(){ ready(function(){ inject(document); }); });
  // caroselli/AJAX aggiungono card dopo: re-inietta su mutazioni (debounced)
  if(window.MutationObserver){
    var pend=false;
    new MutationObserver(function(){ if(pend) return; pend=true; (window.requestAnimationFrame||setTimeout)(function(){ pend=false; if(api()) inject(document); }); })
      .observe(document.documentElement, {childList:true, subtree:true});
  }
})();

/* ============ MOBILE UX (audit 2026-06-12): ricerca header, sticky ATC, barra filtri, pulse, reveal ============ */
(function(){
  'use strict';
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function isMobile(){ return window.matchMedia('(max-width:991px)').matches; }

  /* marker pagina per il CSS contestuale (badge recensioni, ecc.) */
  ready(function(){
    if(document.querySelector('.product-page-info')) document.body.classList.add('ifdp-is-product');
    if(document.body.classList.contains('template-cart')) document.body.classList.add('ifdp-is-cart');
  });

  /* --- Ricerca 1-tap nel header mobile: apre il drawer e mette a fuoco il campo --- */
  ready(function(){
    var ham=document.querySelector('.header__line-top .header__btn-menu')||document.querySelector('.header__btn-menu');
    if(!ham || document.querySelector('.ifdp-msearch')) return;
    var a=document.createElement('a');
    a.href='#'; a.className='ifdp-msearch'; a.setAttribute('aria-label',ifdpText("Cerca","Search"));
    a.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.5-4.5"/></svg>';
    ham.parentNode.insertBefore(a, ham.nextSibling); /* iter-5: a sinistra accanto all'hamburger (la sidebar destra e' width:90px per 2 icone: una terza viene schiacciata dal flex-shrink) */
    a.addEventListener('click', function(e){
      e.preventDefault();
      var btn=document.querySelector('[data-js-popup-button="navigation"]');
      if(btn) btn.click();
      setTimeout(function(){
        var inp=document.querySelector('.popup-navigation__search input[type="search"], .popup-navigation input[name="q"]');
        if(inp) inp.focus();
      }, 420);
    });
  });

  /* --- Barra azioni del pannello filtri (mobile): visibile via body.ifdp-filters-open --- */
  ready(function(){
    if(document.querySelector('.ifdp-filterbar') || !document.querySelector('.collection-filters')) return;
    var bar=document.createElement('div');
    bar.className='ifdp-filterbar';
    bar.innerHTML='<button type="button" class="ifdp-filterbar__clear">'+ifdpText("Cancella tutto","Clear all")+'</button><button type="button" class="ifdp-filterbar__apply">'+ifdpText("Mostra risultati","Show results")+'</button>';
    document.body.appendChild(bar);
    bar.addEventListener('click', function(e){
      if(e.target.closest('.ifdp-filterbar__apply')){ document.body.classList.remove('ifdp-filters-open'); return; }
      if(e.target.closest('.ifdp-filterbar__clear')){
        var native=[].slice.call(document.querySelectorAll('.collection-filters a, .collection-filters button')).filter(function(el){ return /^(?:cancella tutto|clear all)$/i.test(el.textContent||''); })[0];
        document.body.classList.remove('ifdp-filters-open');
        if(native){ native.click(); } else { location.href=location.pathname; }
      }
    });
  });

  /* --- Feedback aggiunta al carrello: pulse sull'icona header --- */
  document.addEventListener('theme:cart::added', function(){
    var ic=document.querySelector('.header__btn-cart');
    if(!ic) return;
    ic.classList.remove('ifdp-pulse');
    void ic.offsetWidth;
    ic.classList.add('ifdp-pulse');
    setTimeout(function(){ ic.classList.remove('ifdp-pulse'); }, 600);
  });

  /* --- Reveal-on-scroll one-shot: solo home, solo sezioni sotto il fold.
     Listener scroll in capture sul document: funziona con qualunque scroll-container
     (il body del tema ha overflow custom che rende inaffidabili window-scroll e IO). --- */
  ready(function(){
    if(location.pathname!=='/' ) return;
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var secs=[].slice.call(document.querySelectorAll('main .shopify-section, #MainContent .shopify-section'))
      .filter(function(s){ return s.getBoundingClientRect().top > window.innerHeight; });
    if(!secs.length) return;
    secs.forEach(function(s){ s.classList.add('ifdp-reveal'); });
    var pending=false;
    function check(){
      pending=false;
      for(var i=secs.length-1; i>=0; i--){
        var r=secs[i].getBoundingClientRect();
        if(r.top < window.innerHeight*0.96){ secs[i].classList.add('is-in'); secs.splice(i,1); }
      }
      if(!secs.length){ document.removeEventListener('scroll', onScroll, true); }
    }
    function onScroll(){ if(!pending){ pending=true; (window.requestAnimationFrame||setTimeout)(check); } }
    document.addEventListener('scroll', onScroll, {capture:true, passive:true});
    window.addEventListener('resize', onScroll, {passive:true});
    check();
  });
})();

/* --- MOBILE NAV REWORK v2 (2026-06-12): icona hamburger pulita.
   Il glifo nativo Shella (menu+lente fusi) e' confuso accanto alle altre icone:
   swap con un hamburger a 3 linee, stesso bottone/handler nativi. --- */
(function(){
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function(){
    if(!window.matchMedia('(max-width:991px)').matches) return;
    var btn=document.querySelector('.header__btn-menu');
    if(!btn) return;
    var host=btn.querySelector('i')||btn;
    host.innerHTML='<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M3.5 6.5h17M3.5 12h17M3.5 17.5h17"/></svg>';
  });
})();
